import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, type ModelRef } from 'vue'
import { useStore } from 'vuex'
import SelectButton from 'primevue/selectbutton'
import { getQuestionTypeOptions } from '@/entities'

interface Props {
    disabled: boolean
    activeMetrics: string[]
    isMultiMetric: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBarQuestionType',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean, default: false },
    activeMetrics: {},
    isMultiMetric: { type: Boolean }
  }, {
    "modelValue": {
    },
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['filterChanged'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()
const questionTypes = getQuestionTypeOptions()

const defaultActiveMetric = computed(() => props.activeMetrics[0])
// for possible metric values, see getQuestionTypeOptions() > 'name' property
const metric: ModelRef<string | undefined> = _useModel(__props, "modelValue", {
    get(value) {
        return value ?? defaultActiveMetric.value
    },
})

const metricOptions = computed(() => {
    // Does not display select button when empty/They only use one metric type
    if (!props.isMultiMetric) {
        return []
    }
    return questionTypes.filter((questionType) =>
        props.activeMetrics.includes(questionType.name)
    )
})

const ptSelectButton = {
    root: { class: 'filter-select-button' },
}

return (_ctx: any,_cache: any) => {
  return (metricOptions.value.length > 1)
    ? (_openBlock(), _createBlock(_unref(SelectButton), {
        key: 0,
        modelValue: metric.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((metric).value = $event)),
        options: metricOptions.value,
        disabled: _ctx.disabled,
        "allow-empty": false,
        "option-label": "label",
        "option-value": "name",
        pt: ptSelectButton,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('filterChanged')))
      }, null, 8, ["modelValue", "options", "disabled"]))
    : _createCommentVNode("", true)
}
}

})